<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item :label="$t('groupmanage.gname')">
        <el-input :placeholder="$t('groupmanage.placeholder')" v-model="filter.groupName" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t('publics.querybtn') }}</el-button>
        <el-button   icon="el-icon-plus" type="success"
          @click="onAdd" v-permision_tjtf="'add'">{{ $t('publics.add') }}</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column :label="$t('groupmanage.table.serial')" type="index" width="80"></el-table-column>
      <el-table-column :label="$t('groupmanage.table.group_name')" prop="group_name"></el-table-column>
      <el-table-column :label="$t('groupmanage.table.PlatformName')" prop="PlatformName"></el-table-column>
      <el-table-column :label="$t('groupmanage.table.SMSaccessKeyId')" prop="SMSaccessKeyId"></el-table-column>
      <el-table-column :label="$t('groupmanage.table.SMSaccessKeySecret')" prop="SMSaccessKeySecret"></el-table-column>
      <el-table-column :label="$t('groupmanage.table.SMSSignName')" prop="SMSSignName"></el-table-column>
      <el-table-column :label="$t('groupmanage.table.SMSTemplateCode')" prop="SMSTemplateCode"></el-table-column>
      <el-table-column :label="$t('groupmanage.table.create_time')" prop="create_time"></el-table-column>
      <el-table-column :label="$t('publics.operation')" width="240px">
        <template slot-scope="{row}">
          <el-button type="text" @click="onUpdate(row)">{{ $t('publics.edit') }}</el-button>
          <el-button type="text"   @click="onDelete(row)">{{
            $t('publics.delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="sizes,total,prev,pager,next,jumper" :total="pageParams.total"
        :page-size="pageParams.limit" :page-sizes="[5, 10, 50, 100, 500, 1000]" :current-page="pageParams.page"
        @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>


    <!-- 新增or修改集团 -->
    <el-dialog :visible.sync="visible.editGroup"
      :title="isUpdate ? $t('groupmanage.editortitle') : $t('groupmanage.appendtitle')" width="1000px">
      <el-row type="flex" justify="center">
        <el-col :span="20">
          <el-form label-position="right" label-width="100px" :model="form" :rules="formRules" ref="groupForm">
            <el-form-item :label="$t('groupmanage.table.group_name')" prop="groupName" label-width="20%">
              <el-input :placeholder="$t('groupmanage.placeholder')" v-model="form.groupName" />
            </el-form-item>
            <el-form-item :label="$t('groupmanage.table.PlatformName')" prop="platformName" label-width="20%">
              <el-input :placeholder="$t('groupmanage.placeholder1')" v-model="form.platformName" />
            </el-form-item>
            <el-form-item :label="$t('groupmanage.table.SMSaccessKeyId')" prop="accessKeyId" label-width="20%">
              <el-input :placeholder="$t('groupmanage.placeholder2')" v-model="form.accessKeyId" />
            </el-form-item>
            <el-form-item :label="$t('groupmanage.table.SMSaccessKeySecret')" prop="accessKeySecret" label-width="20%">
              <el-input :placeholder="$t('groupmanage.placeholder3')" v-model="form.accessKeySecret" />
            </el-form-item>
            <el-form-item :label="$t('groupmanage.table.SMSSignName')" prop="SignName" label-width="20%">
              <el-input :placeholder="$t('groupmanage.placeholder4')" v-model="form.SignName" />
            </el-form-item>
            <el-form-item :label="$t('groupmanage.table.SMSTemplateCode')" prop="TemplateCode" label-width="20%">
              <el-input :placeholder="$t('groupmanage.placeholder5')" v-model="form.TemplateCode" />
            </el-form-item>
            <el-form-item :label="$t('groupmanage.table.platformLogo')" prop="platformLogo" label-width="20%">
              <file-upload listType="picture-card" :limit="1" @fileChange="fileChange" field="platformLogo"
                :fileList="form.platformLogo"></file-upload>
            </el-form-item>
            <!-- <el-form-item label="主题" prop="platformTheme">
              <el-select v-model="form.platformTheme">
                <el-option label="浅色" :value="1"></el-option>
                <el-option label="深色" :value="2"></el-option>
              </el-select>
            </el-form-item> -->
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="visible.editGroup = false">{{ $t('groupmanage.cancelbtn') }}</el-button>
        <el-button type="primary" @click="onSubmit">{{ $t('groupmanage.confirmbtn') }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import pageMixin from '@/mixins/pageMixin';
import fileUpload from '@/components/fileUpload/fileUpload.vue';
import { addGroup, deleteGroup, updateGroup, getGroups } from '@/api/user';
import { mapGetters } from 'vuex';
export default {
  name: 'GroupManage',
  mixins: [pageMixin],
  components: { fileUpload },
  data() {
    return {
      visible: {
        editGroup: false,
      },
      tableData: [],
      form: {
        groupName: '',
        platformName: '',
        platformLogo: [],
        platformTheme: 1,
        accessKeyId: '',
        accessKeySecret: '',
        SignName: '',
        TemplateCode: ''
      },
      formRules: {},
      filter: {
        groupName: ''
      },
      loading: false,
      isUpdate: true,
      gid: '',  //集团id
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created() {
    this.formRules = {
      groupName: [
        { required: true, message: this.$t('groupmanage.placeholder'), trigger: 'blur' }
      ],
      platformName: [
        { required: true, message: this.$t('groupmanage.placeholder1'), trigger: 'blur' }
      ],
      accessKeyId: [
        { required: true, message: this.$t('groupmanage.placeholder2'), trigger: 'blur' }
      ],
      accessKeySecret: [
        { required: true, message: this.$t('groupmanage.placeholder3'), trigger: 'blur' }
      ],
      SignName: [
        { required: true, message: this.$t('groupmanage.placeholder4'), trigger: 'blur' }
      ],
      TemplateCode: [
        { required: true, message: this.$t('groupmanage.placeholder5'), trigger: 'blur' }
      ],
      platformLogo: [
        { required: true, message: this.$t('groupmanage.placeholder6'), trigger: 'blur' }
      ],
      //platformTheme: [
      //  { required: true, message: '请选择平台主题', trigger: 'change' }
      //]
    };
    this.getData();
  },
  methods: {
    onUpdate(row) {
      this.visible.editGroup = true;
      this.isUpdate = true;
      this.form.groupName = row.group_name;
      this.form.platformName = row.PlatformName;
      this.form.platformLogo = row.PlatformLogoPath ? [{ url: row.PlatformLogoPath }] : [];
      this.form.platformTheme = row.PlatformThemeColors;
      this.form.accessKeyId = row.SMSaccessKeyId;
      this.form.accessKeySecret = row.SMSaccessKeySecret;
      this.form.SignName = row.SMSSignName;
      this.form.TemplateCode = row.SMSTemplateCode;
      this.gid = row.ID;
    },
    fileChange(fileList, field) {
      this.form[field] = fileList;
    },
    onDelete(row) {
      this.$confirm(`${this.$t('groupmanage.removetitle')}`, `${this.$t('groupmanage.tic')}`, {
        type: 'warning'
      }).then(() => {
        deleteGroup([row.ID]).then(res => {
          this.$message.success(`${this.$t('publics.deletesuccessful')}`);
          this.toFilter();
        })
      }).catch(() => { })
    },
    getData() {
      this.loading = true;
      getGroups({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        name: this.filter.groupName || null
      }).then(res => {
        this.tableData = res.data;
        this.pageParams.total = res.total;
      }).finally(() => { this.loading = false; })
    },
    onAdd() {
      this.visible.editGroup = true;
      this.isUpdate = false;
      this.form = this.$options.data().form;
    },
    onSubmit() {
      this.$refs.groupForm.validate(valid => {
        if (valid) {
          const loading = this.$loading();
          const reqData = {
            group_name: this.form.groupName,
            PlatformName: this.form.platformName,
            PlatformLogoPath: this.form.platformLogo.length ? this.form.platformLogo[0].url : '',
            PlatformThemeColors: this.form.platformTheme || 1,
            SMSaccessKeyId: this.form.accessKeyId,
            SMSaccessKeySecret: this.form.accessKeySecret,
            SMSSignName: this.form.SignName,
            SMSTemplateCode: this.form.TemplateCode
          }
          if (this.isUpdate) {
            reqData.ID = this.gid;
            updateGroup(reqData).then(res => {
              this.$message.success(`${this.$t('publics.modifiedsuccessful')}`);
              this.visible.editGroup = false;
              this.toFilter();
            }).finally(() => { loading.close() })
          } else {
            addGroup(reqData).then(res => {
              this.$message.success(`${this.$t('publics.addedsuccessful')}`);
              this.visible.editGroup = false;
              this.toFilter();
            }).finally(() => { loading.close() })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}
</style>